module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/static-modal-app/img/button-android@2x__b2876c88c73c07052fceeb37c1271309.png";